import * as React from "react";

function SvgExpandCollapseRight() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path id="Icon_open-collapse-left" data-name="Icon open-collapse-left" d="M0,0V16H2V0ZM12,0V16h4V0ZM10,4,6,8l4,4Z" transform="translate(16 16) rotate(180)" fill="#284672 " />
        </svg>

    )
}
export default SvgExpandCollapseRight;


// WEBPACK FOOTER //
// ./src/iconComponents/rightCollapseExpandIcon.js